<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useContactLabelsStore } from 'dashboard/stores/contactLabels';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const contactLabelsStore = useContactLabelsStore();

onMounted(() => {
  store.dispatch('campaigns/get');
  contactLabelsStore.fetchAll();
});
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-surface-1"
  >
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
